<template lang="pug">
page-layout#parcels(:heading='heading' :num-of-slide-outs='1')
	.link-container(slot='link-container')
		a.arc-gis(href='https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/k6MSf292j6S0mvLo/ArcGIS/rest/services/Parcels_Oct082020/FeatureServer/0' target='_blank') ARC GIS
			span.icon-export
	asset-table(
		slot='content'
		asset-name='parcels'
		asset-key='parcelsKey'
		search-text='Search for a Report'
		:config='config'
		:get-all='GetParcels'
		:search='SearchParcels'
		:download-csv='DownloadParcelsCSV'
		:download-pdf='DownloadParcelsPDF'
		@row-clicked='viewParcel'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';

import {
	GetParcels,
	DownloadParcelsCSV,
	DownloadParcelsPDF,
	SearchParcels
} from '@/lib/API';

// eslint-disable-next-line no-unused-vars
import Submit from '@/lib/Submit';
import {
	// eslint-disable-next-line no-unused-vars
	FilterToAPI,
	// eslint-disable-next-line no-unused-vars
	SortToAPI
} from '@/lib/utils';

// eslint-disable-next-line no-unused-vars
import { dateOf } from '@/lib/time';
// eslint-disable-next-line import/named
//import { editParcel } from '@/lib/generate';

export default {
	name : 'parcels',

	data : () => ( {

		heading : {
			title       : 'Parcel Look-Up',
			description : 'Click any row to view parcel lookup in GIS',
		},

		config : {
			columns : {

				apn : {
					title  : 'APN',
					sort   : 'string',
					filter : 'string',
					index  : true,
					hidden : false,
					order  : 0,
				},

				agencyCode : {
					title  : 'Agency Code',
					sort   : 'number',
					filter : 'string',
					hidden : false,
					order  : 1,
				},

				name : {
					title  : 'Owner',
					sort   : 'string',
					filter : 'string',
					index  : true,
					weight : 10,
					hidden : false,
					order  : 2,
				},

				address : {
					title  : 'Address Line 1',
					sort   : 'string',
					filter : 'string',
					index  : true,
					hidden : false,
					order  : 3,
				},

				addressTwo : {
					title  : 'Address Line 2',
					sort   : 'string',
					filter : 'string',
					index  : true,
					hidden : false,
					order  : 4,
				},

				city : {
					title  : 'City',
					sort   : 'string',
					filter : 'string',
					index  : true,
					hidden : false,
					order  : 5,
				},

				state : {
					title  : 'State',
					sort   : 'string',
					filter : 'string',
					index  : true,
					hidden : false,
					order  : 6,
				},

				zipCode : {
					title  : 'Zip Code',
					sort   : 'number',
					filter : 'string',
					hidden : false,
					order  : 7,
				},

			},
		},

		parcelPageState    : 'closed',
		parcelLoadingState : 'loaded',
		activeParcel       : {},

		GetParcels,
		DownloadParcelsCSV,
		DownloadParcelsPDF,
		SearchParcels
	} ),

	methods : {

		parcelForm() {
			this.$store.dispatch( 'form', {
				type : 'parcel',
			} );
		},

		viewParcel( parcel ) {

			if ( !parcel.address || !parcel.city || !parcel.state || !parcel.apn ) {
				return;
			}

			window
				.open(
					`https://www.arcgis.com/home/webmap/viewer.html?find=${parcel.address},${parcel.city},${parcel.state}&url=https://services.arcgis.com/k6MSf292j6S0mvLo/ArcGIS/rest/services/Parcels_Oct082020/FeatureServer/0/query?where=APN%20%3D%20%27${parcel.apn}%27`,
					'_blank'
				);

			// this.parcelPageState    = 'opened';
			// this.parcelLoadingState = 'loading';

			// this.activeParcel = GetParcels( parcelIndex, parcel );
		},

		closeParcel() {
			this.parcelPageState = 'closed';
			this.activeParcel    = null;
		},

		//editParcel() {
		//	const { parcelKey } = this.activeParcel;
		//	const startingData  = editParcel();
    //
		//	this.parcelForm( startingData, parcelKey );
		//},

		updateAsset( newAsset ) {
			this.activeParcel = newAsset;
		}

	},

	components : {
		AssetTable,
		PageLayout,
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#parcels {

	.arc-gis {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		color: $input-color;
		font-weight: 500;
		letter-spacing: 1.5px;

		.icon-export {
			color: inherit;
			margin-left: 20px;
			font-weight: 700;
		}
	}
}

.space-form.developer-form {
	@include set-form-color( #8089BA );

	.drop-box-wrapper .background {
		background: lighten( #8089BA, 30% );
	}
}
</style>
